import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const BlogsPagePageSession = React.lazy(() => import('../blogs/BlogsPageSession'));
const BlogsPageHeader = React.lazy(() => import('../blogs/BlogsPageHeader'));

function BlogsPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <BlogsPageHeader />
       <BlogsPagePageSession />
      </Suspense>
    </div>
  );
}

export default BlogsPage;
